import script from "./container.vue?vue&type=script&setup=true&name=containerBox&lang=js"
export * from "./container.vue?vue&type=script&setup=true&name=containerBox&lang=js"

import "./container.vue?vue&type=style&index=0&id=2bf4c1d1&scoped=true&lang=css"
import "./container.vue?vue&type=style&index=1&id=2bf4c1d1&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf4c1d1"]])

export default __exports__